import React from 'react';

const ProfessionalExperience = () => {
  return (
    <section className="professional-experience">
      <h2>Professional Experience</h2>
      <div className="experience-item">
        <h3 className="company">Contentful</h3>
        <h4 className="position">February 2025 - Present</h4>
        <h5 className="position">Revenue Operations Analyst (Field Strategy and Planning)</h5>
        <ul>
          <li><strong>Sales Capacity Planning:</strong> Lead the development and management of the sales capacity model to ensure alignment with organisational goals.</li>
          <li><strong>Analysis:</strong> Partner regularly with Sales Leaders to interpret data, key trends, and identify areas requiring additional focus. I combined various data sourced to create an intent dashboard that supports our outbounding motion.</li>
          <li><strong>GTM Operations:</strong> Support the running of the EMEA pipeline call to drive actionable insights and alignment. I'm working on automating parts of our QBR to increase efficiency - if you've worked on this before get in touch, I would love to hear from you!</li>
        </ul>
      </div>
      <div className="experience-item">
        <h3 className="company">Group GTI</h3>
        <h4 className="position">July 2021 - February 2025</h4>
        <h5 className="position">Revenue Operations Manager</h5>
        <ul>
          <li><strong>Process Implementation & Improvements:</strong>  Refined the customer journey on our CRM to improve forecasting and overall opportunity management.</li>
          <li><strong>Analysis:</strong> Using SQL and Excel, I calculated the Total Addressable Market to enable the go-to-market team to target a specific set of organisations, and I conducted sector analysis to determine our potential growth opportunities within each sector.</li>
          <li><strong>Sales Operations:</strong> Worked with the customer success team to improve our subscription delivery process (using Planhat and Zoho CRM).</li>
        </ul>
      </div>
    </section>
  );
};

export default ProfessionalExperience;

